define('SC.ManorThemeExtension.Home', [
  'underscore',
  'SC.ManorThemeExtension.Common.Configuration',
  'SC.ManorThemeExtension.Common.LayoutHelper'
], function ThemeExtensionHome(_, Configuration, LayoutHelper) {
  'use strict';

  return {
    loadModule: function loadModule() {
      // for Carousel
      var carousel = Configuration.get('home.themeCarouselImages', []);
      var infoBlocks = Configuration.get('home.infoblock', []);
      var infoBlocksMore = Configuration.get('home.infoblockmore', []);
      var showCarousel = false;
      var carouselObj;
      var isReady = false;
      var heros = Configuration.get('home.hero', []);
      var firstHero = heros[0];

      LayoutHelper.addToViewContextDefinition(
        'Home.View',
        'extraHomeView',
        'object',
        function (context) {
          carouselObj = context.carousel;
          isReady =
            _.has(context, 'isReady') && !_.isUndefined(context.isReady)
              ? context.isReady
              : true;

          if (!_.isEmpty(carouselObj)) {
            _.each(carouselObj, function (carousel) {
              if (!_.isEmpty(carousel.image)) {
                _.extend(carousel, {
                  isAbsoluteUrl: carousel.image.indexOf('core/media') !== -1
                });
              }
            });
          } else {
            carouselObj = carousel;
          }

          return {
            isReady: isReady,
            showCarousel: carouselObj && !!carouselObj.length,
            carousel: carouselObj,
            showInfoblocks: infoBlocks && !!infoBlocks.length,
            infoBlocks: infoBlocks,
            showInfoblocksMore: infoBlocksMore && !!infoBlocksMore.length,
            infoBlocksMore: infoBlocksMore,
            hero: firstHero
          };
        }
      );
    }
  };
});
